 import { Bank } from "../types/bank"; 
import { createApiStore } from "./genericStore";
 
export const useBankStore = createApiStore<Bank>("/bank");
